import { Link } from "@tanstack/react-router";

export const TeaserCard = ({
  title,
  description,
  image,
  link,
  children,
}: {
  title: string;
  description: string;
  image: string;
  link: string;
  children?: React.ReactNode;
}) => {
  return (
    <Link
      to={link}
      className="flex flex-col gap-4 p-3.5 bg-neutral-lightest rounded-lg"
    >
      <img
        src={image}
        alt=""
        className="w-full h-full object-cover rounded-md aspect-327/228"
      />
      <div className="flex flex-col gap-2">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm -mt-2 mb-2 line-clamp-2">{description}</p>
        {children}
      </div>
    </Link>
  );
};
